import React from 'react';
import Select from 'react-select';

const disciplines = [
  { value: 0, label: 'Addiction Services'},
  { value: 1, label: 'Allergy Medicine'},
  { value: 2, label: 'Anaesthesia / Pain Management'},
  { value: 3, label: 'Audiology'},
  { value: 4, label: 'Breast Surgery'},
  { value: 5, label: 'Cardiology'},
  { value: 6, label: 'Cardiothoracic Surgery'},
  { value: 7, label: 'Child and Adolescent Psychiatry'},
  { value: 8, label: 'Chiropody'},
  { value: 9, label: 'Colorectal Surgery'},
  { value: 10, label: 'Counselling / Psychotherapy'},
  { value: 11, label: 'Dentistry'},
  { value: 12, label: 'Dermatology'},
  { value: 13, label: 'Diagnostic Imaging'},
  { value: 14, label: 'Dietician'},
  { value: 15, label: 'Driving Assessments'},
  { value: 16, label: 'Ear Nose & Throat Medicine'},
  { value: 17, label: 'Emergency Medicine'},
  { value: 18, label: 'Endocrinology'},
  { value: 19, label: 'Gastroenterology'},
  { value: 20, label: 'General Medicine'},
  { value: 21, label: 'General Practice'},
  { value: 22, label: 'General Surgery'},
  { value: 23, label: 'Genetics'},
  { value: 24, label: 'Haematology'},
  { value: 25, label: 'Healthcare Risk Management'},
  { value: 26, label: 'Health Centre'},
  { value: 27, label: 'Health Screening'},
  { value: 28, label: 'Hepatology'},
  { value: 29, label: 'Histopathology'},
  { value: 30, label: 'Home Care'},
  { value: 31, label:'HSE Facility'},
  { value: 32, label: 'Immunology'},
  { value: 33, label: 'Infectious Diseases'},
  { value: 34, label: 'Intellectual Disability'},
  { value: 35, label:  'Laboratory Services'},
  { value: 36, label: 'Legal Services'},
  { value: 37, label: 'Long Term Care Facility'},
  { value: 38, label: 'Maxillofacial Surgery'},
  { value: 39, label: 'Medicine for the Elderly'},
  { value: 40, label:'Microbiology'},
  { value: 41, label: 'Minor Surgery'},
  { value: 42, label: 'Neurology'},
  { value: 43, label: 'Neurophysiology'},
  { value: 44, label: 'Neurosurgery'},
  { value: 45, label: 'Obstetrics & Gynaecology'},
  { value: 46, label: 'Occupational Health'},
  { value: 47, label: 'Occupational Therapy'},
  { value: 48, label: 'Oncology'},
  { value: 49, label: 'Ophthalmology'},
  { value: 50, label: 'Optometry'},
  { value: 51, label: 'Oral Surgery'},
  { value: 52, label: 'Orthopaedics'},
  { value: 53, label: 'Orthoptics'},
  { value: 54, label: 'Paediatrics'},
  { value: 55, label: 'Palliative Care Medicine'},
  { value: 56, label: 'Patient Support Group'},
  { value: 57, label: 'Pharmacy'},
  { value: 58, label: 'Physiotherapy'},
  { value: 59, label: 'Plastic Surgery'},
  { value: 60, label: 'Podiatry'},
  { value: 61, label: 'Practice Nurse'},
  { value: 62, label: 'Psychiatry'},
  { value: 63, label: 'Psychiatry of Old Age'},
  { value: 64, label: 'Psychology'},
  { value: 65, label: 'Public Health Medicine'},
  { value: 66, label: 'Public Health Nursing'},
  { value: 67, label: 'Radiation Oncology'},
  { value: 68, label: 'Radiology'},
  { value: 69, label: 'Renal Medicine / Nephrology'},
  { value: 70, label: 'Respiratory'},
  { value: 71, label: 'Rheumatology'},
  { value: 72, label: 'Sexual and Reproductive Health'},
  { value: 73, label: 'Sleep Disorder Medicine'},
  { value: 74, label: 'Smoking Cessation'},
  { value: 75, label: 'Speech and Language Therapy'},
  { value: 76, label: 'Sports Medicine'},
  { value: 77, label: 'Travel Medicine'},
  { value: 78, label: 'Urology'},
  { value: 79, label: 'Vascular Surgery'},
  { value: 80, label:'Virology'}
]

class DisciplineTagSelect extends React.Component {

  render () {
    const {value, onChange, errors} = this.props;

    return (
      <div>
        <div className="col s12">
           <p className="input_country"><div style={{marginBottom: '11px'}}></div></p>
          {/*<Select*/}
          {/*  options={disciplines}*/}
          {/*  placeholder='Select disciplines'*/}
          {/*  value={value}*/}
          {/*  onChange={onChange}*/}
          {/*  multi={true}*/}
          {/*/>*/}
          <div style={{ color: 'red', fontSize: '0.875rem' }}>
            {(errors || []).join('. ')}
          </div>
        </div>
      </div>
    )
  }
}

export default DisciplineTagSelect;



// WEBPACK FOOTER //
// ./src/containers/Input/DisciplineTagSelect.jsx